import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Group } from '../models/group';
import { IGenericJSON } from '../helpers/interface';

export interface CreateGroupPayload {
  name: string;
  description?: string;
  icon?: string | null;
}

export interface UpdateGroupPayload {
  name?: string;
  description?: string;
  icon?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GroupService {
  private http: HttpClient = inject(HttpClient);

  constructor() {}

  getManagedGroups(): Observable<Group[]> {
    return this.http
      .get<IGenericJSON[]>(`/api/groups/managed-groups`)
      .pipe(map((data) => Group.digestResponse(data)));
  }

  getGroups(search?: string): Observable<Group[]> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }

    return this.http
      .get<IGenericJSON[]>(`/api/groups`, { params })
      .pipe(map((data) => Group.digestResponse(data)));
  }

  createGroup(payload: CreateGroupPayload): Observable<Group> {
    return this.http
      .post<IGenericJSON>('/api/groups', payload)
      .pipe(map((data) => Group.digestResponse([data])[0]));
  }

  updateGroup(groupId: number, payload: UpdateGroupPayload): Observable<Group> {
    return this.http
      .put<IGenericJSON>(`/api/groups/${groupId}`, payload)
      .pipe(map((data) => Group.digestResponse([data])[0]));
  }

  removeGroup(groupId: number): Observable<Group> {
    return this.http
      .put<IGenericJSON>(`/api/groups/remove-group/${groupId}`, {})
      .pipe(map((data) => Group.digestResponse([data])[0]));
  }

  addGroupMember(groupId: number, userId: number): Observable<void> {
    return this.http.post<void>(`/api/groups/${groupId}/member/${userId}`, {});
  }

  removeGroupMember(groupId: number, userId: number): Observable<void> {
    return this.http.delete<void>(`/api/groups/${groupId}/member/${userId}`);
  }

  addGroupManager(groupId: number, userId: number): Observable<void> {
    return this.http.post<void>(`/api/groups/${groupId}/manager/${userId}`, {});
  }

  removeGroupManager(groupId: number, userId: number): Observable<void> {
    return this.http.delete<void>(`/api/groups/${groupId}/manager/${userId}`);
  }
}
